import { defineMessages } from 'react-intl';

export default defineMessages({
  featured: {
    id: 'ReactFilters.messages.featured.featured',
    defaultMessage: 'Featured',
  },
});
